import { DocumentationArea } from "src/contexts/documentationArea/domain/DocumentationArea";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";
import { OrderId } from "src/contexts/documentationArea/domain/OrderId";

/**
 * Updates the status of a specific order to "processing" for optimistic UI updates
 * @param documentationArea The documentation area containing the actors and orders
 * @param actorId The ID of the actor whose order should be updated
 * @param orderId The ID of the order to update
 * @returns A new DocumentationArea instance with the updated order status
 */
export function updateOrderStatusToProcessing(
  documentationArea: DocumentationArea,
  actorId: ActorId,
  orderId: OrderId,
): DocumentationArea {
  const actor = documentationArea.getActor();
  if (actor.getId() === actorId) {
    actor.getOrderById(orderId)?.setToProcessing();
  }

  return new DocumentationArea({
    id: documentationArea.getId(),
    type: documentationArea.getType(),
    actor: documentationArea.getActor(),
    availableActors: documentationArea.getAvailableActors(),
    locale: documentationArea.getLocale(),
  });
}
